import React, { useState } from "react";
import styles from "./permissions.module.css";

const allPermissions = [
  "CREATE_BOOK",
  "EDIT_BOOK",
  "DELETE_BOOK",
  "VIEW_PROPOSALS",
  "APPROVE_PROPOSALS",
  "MANAGE_USERS",
  "MANAGE_AUTHORS",
  "MANAGE_PERMISSIONS",
];

const initialRoles = {
  GUEST: {},
  USER: {},
  AUTHOR: { VIEW_PROPOSALS: true, CREATE_BOOK: true, EDIT_BOOK: true },
  MANAGER: {
    CREATE_BOOK: true,
    EDIT_BOOK: true,
    DELETE_BOOK: true,
    VIEW_PROPOSALS: true,
    APPROVE_PROPOSALS: true,
    MANAGE_AUTHORS: true,
  },
  ADMIN: {
    CREATE_BOOK: true,
    EDIT_BOOK: true,
    DELETE_BOOK: true,
    VIEW_PROPOSALS: true,
    APPROVE_PROPOSALS: true,
    MANAGE_USERS: true,
    MANAGE_AUTHORS: true,
    MANAGE_PERMISSIONS: true,
  },
};

export default function PermissionsPage() {
  const [roles, setRoles] = useState(initialRoles);

  const handleCheckboxChange = (role, permission) => {
    setRoles((prevRoles) => {
      const newPermissions = { ...prevRoles[role] };
      newPermissions[permission] = !newPermissions[permission];
      return { ...prevRoles, [role]: newPermissions };
    });
  };

  const handleSaveChanges = () => {
    console.log("Saving new permissions structure:", roles);
    alert("Permissions saved! Check the console for the data structure.");
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <h1 className={styles.header}>Roles & Permissions</h1>
        <button onClick={handleSaveChanges} className={styles.saveButton}>
          Save Changes
        </button>
      </div>

      <p className={styles.description}>
        Control what each user role can do within the application. Changes here
        directly affect user access.
      </p>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.stickyCol}>Permission</th>
              {Object.keys(roles).map((role) => (
                <th key={role}>{role}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {allPermissions.map((permission) => (
              <tr key={permission}>
                <td className={styles.stickyCol}>
                  {permission.replace(/_/g, " ")}
                </td>
                {Object.keys(roles).map((role) => (
                  <td
                    key={`${role}-${permission}`}
                    className={styles.checkboxCell}
                  >
                    <input
                      type="checkbox"
                      checked={!!roles[role][permission]}
                      onChange={() => handleCheckboxChange(role, permission)}
                      disabled={role === "ADMIN"}
                      className={styles.checkbox}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
